<template>
  <div class="container">
    <div class="vx-col flex center">
      <CollaboratorForm v-if="formToLoad === 'collaborator'" />
      <SocietyForm v-if="formToLoad === 'society'" />
      <ContactForm v-if="formToLoad === 'contact'" />
      <ProspectForm v-if="formToLoad === 'prospect'" />
      <ProviderForm v-if="formToLoad === 'providers'" />
      <NetlinkForm v-if="formToLoad === 'netlink'" :dns_id="dns_id" />
      <ContractForm v-if="formToLoad === 'contracts'" />
      <MissionForm v-if="formToLoad === 'missions'" />
      <TaskForm v-if="formToLoad === 'tasks'" />
      <ServiceForm v-if="formToLoad === 'services'" />
      <ProductForm v-if="formToLoad === 'products'" />
      <NetlinkTypeForm v-if="formToLoad === 'netlink_types'" />
      <DnsForm v-if="formToLoad === 'dns'" :type="formType" />
      <PurchaseForm v-if="formToLoad === 'purchases'" :type="formType" />
      <RenewPurchaseForm v-if="formToLoad === 'renewpurchase'" />
    </div>
  </div>
</template>

<script>
import CollaboratorForm from "@/components/forms/collaborator/Collaborator";
import SocietyForm from "@/components/forms/society/Society";
import ContactForm from "@/components/forms/contact/Contact";
import ProspectForm from "@/components/forms/prospect/Prospect";
import ProviderForm from "@/components/forms/provider/Provider";
import NetlinkForm from "@/components/forms/netlink/Netlink";
import ContractForm from "@/components/forms/contract/Contract";
import MissionForm from "@/components/forms/mission/Mission";
import TaskForm from "@/components/forms/task/Task";
import ServiceForm from "@/components/forms/service/Service";
import ProductForm from "@/components/forms/product/Product";
import NetlinkTypeForm from "@/components/forms/netlink/NetlinkType";
import DnsForm from "@/components/forms/dns/Dns";
import PurchaseForm from "@/components/forms/purchase/Purchase";
import RenewPurchaseForm from "@/components/forms/purchase/RenewPurchase";

//////////////////////////////////////////////////////////
//                                                      //
// THIS PAGE HANDLE ALL FORMS FROM THE DASHBOARD PAGES  //
//                                                      //
//////////////////////////////////////////////////////////

export default {
	name: "NewEntity",
	data() {
		return {
			formToLoad: "",
			formType: null,
			dns_id: "",
		};
	},
	components: {
		SocietyForm,
		CollaboratorForm,
		ContactForm,
		ProspectForm,
		ProviderForm,
		NetlinkForm,
		ContractForm,
		MissionForm,
		TaskForm,
		ServiceForm,
		ProductForm,
		NetlinkTypeForm,
		DnsForm,
		PurchaseForm,
		RenewPurchaseForm
	},
	created() {
		if(this.$route.params.type){
			this.formType = this.$route.params.type;
		}
		if(this.$route.params.dns){
			this.dns_id = this.$route.params.dns;
		}
		if(this.$route.params.newEntityForm) {
			this.formToLoad = this.$route.params.newEntityForm;
		}
		else{
			this.formToLoad = sessionStorage.getItem("prevRoute");
		}
		//console.log(this.formToLoad);
	},
	beforeRouteEnter(to, from, next) {
		// Save the previous route name in the session storage
		sessionStorage.setItem("prevRoute", from.name);
		next();
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}
</style>
